
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","data-name":"vuesax/twotone/receipt-item"}},[_c('path',{attrs:{"d":"M17.417 4.75v1.915a1.9 1.9 0 01-2.042 2.043h-2.708V3.174a1.6 1.6 0 011.6-1.591 3.162 3.162 0 013.15 3.167z","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1.583 5.541v11.084a.789.789 0 001.267.633l1.353-1.013a.8.8 0 011.045.079l1.315 1.322a.8.8 0 001.124 0l1.33-1.33a.785.785 0 011.029-.071l1.354 1.013a.793.793 0 001.267-.633V3.166a1.588 1.588 0 011.583-1.583h-9.5A2.831 2.831 0 001.583 4.75z","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7.125 10.3H9.5M7.125 7.133H9.5","stroke-width":"1.5","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M4.747 10.292h.007M4.747 7.125h.005","stroke-width":"2","opacity":".4"}})])])
          )
        }
      }
    